import { Grid, Box, Container } from "@material-ui/core";
import React from "react";
import { allReviews, ReviewView } from "../../components/Review";

export const ReviewsPage: React.FC = () => {
  const reviews = allReviews
    .sort((a, b) => b.timestamp - a.timestamp)
    .map((review) => (
      <Grid key={review.name} item xs={12} sm={6}>
        <ReviewView
          name={review.name}
          stars={review.stars}
          description={review.description}
          timestamp={review.timestamp}
          full={true}
        />
      </Grid>
    ));

  return (
    <Box my={3}>
      <Container maxWidth="lg">
        <Grid container spacing={3}>
          {reviews}
        </Grid>
      </Container>
    </Box>
  );
};
